import actions1 from './actions1';
import actions2 from './actions2';

export default {
  ...actions1,
  ...actions2
};
